module.exports = __webpack_public_path__ + "static/img/vulva-repair.81a11602.png";